import { resolve as e } from "@scalar/workspace-store/resolve";
import { isArraySchema as t } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/get-schema-type.ts
var n = (e) => e ? `array ${e.includes(" | ") ? `(${e})` : e}[]` : "array", r = (t, r = !1) => {
	if (!t.items) return "array";
	let a = n(i(e.schema(t.items)));
	return r ? a : t.nullable ? `${a} | null` : a;
}, i = (n) => {
	if (!n) return "";
	let i = e.schema(n);
	if (i.const !== void 0) return "const";
	if ("type" in i && Array.isArray(i.type)) {
		if (i.type.includes("array") && i.items) {
			let e = r(i, !0), t = i.type.filter((e) => e !== "array");
			return t.length > 0 ? `${e} | ${t.join(" | ")}` : e;
		}
		return i.type.join(" | ");
	}
	return t(i) ? r(i, !1) : "type" in i && i.type && i.contentEncoding ? `${i.type} • ${i.contentEncoding}` : "type" in i ? i.type : "";
};
//#endregion
export { i as getSchemaType };

//# sourceMappingURL=get-schema-type.js.map